<div class="checkbox-grid-header-cell">
  @if (!isReadOnly && isBulkSupported === true) {
    <input
      class="form-control form-control--checkbox"
      type="checkbox"
      (click)="handleBulkClicked(column)"
      [attr.checked]="checked ? 'checked' : null"
    />
  }
  <p
    [ngClass]="
      isBulkSupported
        ? 'checkbox-grid__bulk-toggle--active'
        : 'checkbox-grid-header-cell__label'
    "
    class="t-data t-bold"
  >
    <label class="checkbox-grid__header-cell-label">{{ column.label }}</label>
  </p>
</div>
